import React from 'react'
import { Link } from 'react-router-dom'

import utils from '../utils'
import LoadingText from '../components/LoadingText'

class DefaultProfileForm extends React.Component {
  state = {
    fields: null,
  }

  componentDidMount() {
    if (this.state.fields !== null) {
      return
    }

    var defaultFields = [
      {
        label: 'Password',
        name: 'password',
        placeholder: 'New password',
        required: false,
        type: 'password',
      },
      {
        label: 'Confirm password',
        name: 'passwordConfirmation',
        placeholder: 'Confirm new password',
        required: false,
        type: 'password',
      },
      {
        label: 'Keys',
        name: 'keys',
        placeholder: '{"torrent9":"xxx", "yggtorrent":"xxx"}',
        required: false,
        type: 'text',
      },
    ]

    this.setState({
      fields: defaultFields,
    })
  }

  render() {
    var fieldMarkup = null

    if (this.state.fields !== null) {
      fieldMarkup = []

      this.state.fields.forEach((field, index) => {
        var fieldId = `sp-${field.name}-${index}`
        fieldMarkup.push(
          <div key={ fieldId } className="form-group">
            <label htmlFor={ fieldId } className="col-xs-12 col-sm-4 control-label">{ field.label }</label>
            <div className="col-xs-12 col-sm-4">
              <input type={ field.type } className="form-control" id={ fieldId } name={ field.name } placeholder={ field.placeholder } required={ field.required } />
            </div>
          </div>
        )
      })

      fieldMarkup.push(
        <div key="register-button" className="form-group">
          <div className="col-sm-offset-4 col-sm-4">
            <p className="alert alert-danger" data-spIf="form.error"><span data-spBind="form.errorMessage" /></p>
            <button type="submit" className="btn btn-primary">Valider</button>
          </div>
        </div>
      )
    }

    return (
      <ProfileForm {...this.props}>
        <div className='sp-login-form'>
          <div className="row" data-spIf="account.created">
            <div className="col-sm-offset-4 col-xs-12 col-sm-4">
              <p className="alert alert-success">
                Votre profil a été mis à jour. <Link to='/'>Retour</Link>.
              </p>
            </div>
          </div>
          <div className="row" data-spIf="!account.created">
            <div className="col-xs-12">
              <div className="form-horizontal">
                { fieldMarkup ? fieldMarkup : <LoadingText /> }
              </div>
            </div>
          </div>
        </div>
      </ProfileForm>
    )
  }
}

export default class ProfileForm extends React.Component {

  state = {
    fields: {
      password: null,
      passwordConfirmation: null,
      keys: null,
    },
    errorMessage: null,
    isFormProcessing: false,
    isAccountCreated: false,
  };

  onFormSubmit(e) {
    e.preventDefault()

    let onSubmitSuccess = this.props.onSubmitSuccess
    let onSubmitError = this.props.onSubmitError

    let setErrorState = (recentError, newError) => {
      this.setState({
        isFormProcessing: false,
        errorMessage: (newError || recentError).message,
      })
    }

    let next = (err, data) => {
      if (err) {
        if (onSubmitError) {
          return onSubmitError({
            data: data,
            error: err,
          }, setErrorState.bind(this, err))
        }

        return setErrorState(err)
      }

      // If the user didn't specify any data,
      // then simply default to what we have in state.
      data = data || this.state.fields

      this.props.updateUser(data.password, data.passwordConfirmation, data.keys, (updated) => {
        if (!updated)
        {
          let err = {'message': 'Update failed'}
          if (onSubmitError) {
            return onSubmitError({
              data: data,
              error: err,
            }, setErrorState.bind(this, err))
          }
          return setErrorState(err)
        }
        else
        {
          let setSuccessState = () => {
            this.setState({
              isFormProcessing: false,
              isAccountCreated: true,
            })
          }

          if (onSubmitSuccess) {
            return onSubmitSuccess({
              data: data,
              result: {'message': 'Update succedeed'},
            }, setSuccessState)
          }

          setSuccessState()
        }
      })
    }

    this.setState({
      isFormProcessing: true,
    })

    if (this.props.onSubmit) {
      e.data = this.state.fields
      this.props.onSubmit(e, next)
    } else {
      next(null, this.state.fields)
    }
  }

  _mapFormFieldHandler(element, tryMapField) {
    let tryMapFormField = (name) => {
      if (name.indexOf('customData.') === 0) {
        tryMapField(name)
        return
      }

      switch(name) {
        case 'password':
          tryMapField('password')
          break
        case 'passwordConfirmation':
          tryMapField('passwordConfirmation')
          break
        case 'keys':
          tryMapField('keys')
          break
        default:
          break
      }
    }

    if (typeof element.type === 'function' && utils.containsWord(element.type.name, ['input', 'field', 'text'])) {
      if (element.props && element.props.name) {
        tryMapFormField(element.props.name)
      }
    } else if (['input', 'textarea'].indexOf(element.type) > -1) {
      if (element.props.type !== 'submit') {
        tryMapFormField(element.props.name)
      }
    }
  }

  _spIfHandler(action, element) {
    var test = null

    switch (action) {
      case 'form.processing':
        test = this.state.isFormProcessing
        break
      case 'form.error':
        test = !!this.state.errorMessage
        break
      case 'account.created':
        test = this.state.isAccountCreated
        break
      default:
        break
    }

    return test
  }

  _spBindHandler(bind, element) {
    var result = false

    switch (bind) {
      case 'form.errorMessage':
        var className = element.props ? element.props.className : undefined
        result = <span className={className}>{this.state.errorMessage}</span>
        break
      default:
        break
    }

    return result
  }

  render() {
    if (this.props.children) {
      var selectedProps = utils.excludeProps(['redirectTo', 'hideSocial', 'onSubmit', 'onSubmitError', 'onSubmitSuccess', 'children', 'updateUser'], this.props)

      return (
        <form onSubmit={this.onFormSubmit.bind(this)} {...selectedProps}>
          {utils.makeForm(this, this._mapFormFieldHandler.bind(this), this._spIfHandler.bind(this), this._spBindHandler.bind(this))}
        </form>
      )
    } else {
      return <DefaultProfileForm {...this.props} />
    }
  }
}
